module.exports = __webpack_public_path__ + "static/media/isa.338534b8.jpg";